import ScrollablePanel from '../../../../../../helpers/src/scrollable-panel/src/scrollable-panel.js';


export default function Dropdowns ()
{
  const topWin = BEditor.environment.topWindow,
        isIE = BEditor.browser.isIE;

  let panelWindow,
      panelDocForSize,
      docForSize;

  this.pDropdown = [];
  this.currentDropdownId = '';
  this.currentMenuDropdownId = '';


  const getDocForSize = (pButton) =>
  {
    panelWindow = (topWin.adminpanel) ? topWin.adminpanel : window;

    panelDocForSize = panelWindow.document.getElementsByTagName('HTML');

    if (panelDocForSize && panelDocForSize.length)
    {
      panelDocForSize = panelDocForSize[0];
    }
    else
    {
      panelDocForSize = panelWindow.document.body;
    }

    docForSize = document.getElementsByTagName('HTML');

    if (docForSize && docForSize.length)
    {
      docForSize = docForSize[0];
    }
    else
    {
      docForSize = document.body;
    }
  };


  this.createDropdown = (objId, pBtn, pParameters, ddInnerHtmlInit, pCallBackSaveInit, pCallBackCloseInit, pCallBackWaitCloseInit, pCallBackStopCloseInit, pCallBackPreviewInit, args = {}) =>
  {
    let i;

    getDocForSize(pBtn);

    for (i = 0; i < this.pDropdown.length; i++)
    {
      if (this.pDropdown[i].id === objId)
      {
        this.pDropdown[i].dropdown.reInitDropdown(objId, pBtn, pParameters, ddInnerHtmlInit, pCallBackSaveInit, pCallBackCloseInit, pCallBackWaitCloseInit, pCallBackStopCloseInit, pCallBackPreviewInit, args);
        return this.pDropdown[i].dropdown;
      }
    }

    i = this.pDropdown.length;
    this.pDropdown[i] = {};
    this.pDropdown[i].id = objId;
    args.ddIndex = i;
    this.pDropdown[i].dropdown = new Dropdown(objId, pBtn, pParameters, ddInnerHtmlInit, pCallBackSaveInit, pCallBackCloseInit, pCallBackWaitCloseInit, pCallBackStopCloseInit, pCallBackPreviewInit, args);

    return this.pDropdown[i].dropdown;
  };


  this.getObjectById = (dropdownId) =>
  {
    for (let i = 0; i < this.pDropdown.length; i++)
    {
      if (this.pDropdown[i].id === dropdownId)
      {
        return this.pDropdown[i].dropdown;
      }
    }

    return null;
  };


  this.checkIfAllDropdownReady = () =>
  {
    for (let i = 0; i < this.pDropdown.length; i++)
    {
      if (!this.pDropdown[i].dropdown.isObjValid)
      {
        return false;
      }
    }

    return true;
  };


  this.closeAllDropdowns = () =>
  {
    for (let i = 0; i < this.pDropdown.length; i++)
    {
      if (this.pDropdown[i].dropdown.getState())
      {
        this.pDropdown[i].dropdown.closeDropdown(null, null, null, true, true);
      }
    }
  };


  function Dropdown(objId, pBtn, pParameters, ddInnerHtmlInit, pCallBackSaveInit, pCallBackCloseInit, pCallBackStopCloseInit, pCallBackWaitCloseInit, pCallBackPreviewInit, args)
  {
    args = args || {};

    var pThis = this;

    this.isObjValid = false;
    this.isDataValid = false;
    this.pButton = pBtn;

    const
          isIFrameTransparent = !!pParameters.isTransparent,
          iFrameBackgroundColor = (pParameters.iFrameBackgroundColor) ? pParameters.iFrameBackgroundColor : '#FFFFFF',
          multiDropdownStructure = (pParameters.multiDropdown) ? pParameters.multiDropdown : null,
          dropdownAlign = (pParameters.dropdownAlign) ? pParameters.dropdownAlign : 'bottom',
          edgeAlign = (pParameters.edgeAlign) ? pParameters.edgeAlign : 'left',
          offsetX = (pParameters.offsetX) ? pParameters.offsetX : 0,
          offsetY = (pParameters.offsetY) ? pParameters.offsetY : 0,
          isNotUnique = pParameters.isNotUnique,
          isWithoutCSS = pParameters.isWithoutCSS,
          zIndexOffset = args.zIndexOffset || 0,
          pCallBackParameters = {},
          childMenuDropdown = [];

    let dropdownId = objId,
        pButton = pBtn,
        directURL = pParameters.directURL,
        ddInnerHTML = (ddInnerHtmlInit) ? ddInnerHtmlInit : '',
        pCallBackSave = (pCallBackSaveInit && typeof(pCallBackSaveInit) === 'function') ? pCallBackSaveInit : null,
        pCallBackClose = (pCallBackCloseInit && typeof(pCallBackCloseInit) === 'function') ? pCallBackCloseInit : this.closeDropdown,
        pCallBackWaitClose = (pCallBackWaitCloseInit && typeof(pCallBackWaitCloseInit) === 'function') ? pCallBackWaitCloseInit : null,
        pCallBackStopClose = (pCallBackStopCloseInit && typeof(pCallBackStopCloseInit) === 'function') ? pCallBackStopCloseInit : function(){},
        pCallBackPreview = (pCallBackPreviewInit && typeof(pCallBackPreviewInit) === 'function') ? pCallBackPreviewInit : null,
        shownMultiDropDownParts = {},
        scrollableDropdownPanel,
        scrollablePanelContainer,
        dropdownInnerMainContainer,
        dropdownInnerContainer,
        multiDropdownPartName = null,
        isMultiDropdown = false,
        newParameters,
        returnParameters = null,
        closeDropdownWaitTM = null,
        changeStateTM = null,
        addHandlersTM = null;

    if (pParameters.callBackParameters)
    {
      for (let i in pParameters.callBackParameters)
      {
        if (pParameters.callBackParameters.hasOwnProperty(i) && typeof(pParameters.callBackParameters[i]) !== 'function')
        {
          pCallBackParameters[i] = pParameters.callBackParameters[i];
        }
      }
    }

    const iFrameId = 'idBaseIFrame_' + dropdownId,
          iFrameName = 'nmBaseIFrame_' + dropdownId,
          dropdownMenuItems = [];

    let objMainBoxCont,
        objMainBox,
        iFrame,
        state = false,
        closeDropdownTM = null,
        iFrameEventElement;


    this.getId = () =>objId;
    this.getIFrame = () => iFrame;
    this.getScrollablePanelContainer = () => scrollablePanelContainer;


    this.focus = () =>
    {
      if (iFrame && iFrame.focus)
      {
        iFrame.focus();
      }
    };


    pThis.DropDownShowed = BEditor.eventHandlers.createHandlers(pThis, {id: 'DropDownShowed'});
    pThis.DropDownHidden = BEditor.eventHandlers.createHandlers(pThis, {id: 'DropDownHidden'});


    const initDropdown = () =>
    {
      if (document && document.body)
      {
        objMainBoxCont = document.createElement('SPAN');
        document.body.appendChild(objMainBoxCont);

        objMainBoxCont.innerHTML = '<iframe id="' + iFrameId + '" name="' + iFrameName + '" src="' + directURL + '" frameborder="0" scrolling="no" ' + ((isIFrameTransparent) ? 'allowtransparency="true" ' : '') + 'style="position: absolute; left: 1px; top: 1px; width: 1px; height: 1px; z-index: ' + (39077 + (BEditor.dropdowns.pDropdown.length * 2) + zIndexOffset) + '; background-color: ' + ((isIFrameTransparent) ? 'transparent' : iFrameBackgroundColor) + '; border: none; -moz-box-shadow: 0 3px 7px rgba(0,0,0,.26); -webkit-box-shadow: 0 3px 7px rgba(0,0,0,.26); box-shadow: 0 3px 7px rgba(0,0,0,.26); padding: 0; margin: 0; visibility: hidden;"></iframe>';

        objMainBox = BEditor.domHelpers.$(iFrameId, window);
        iFrame = frames[iFrameName];

        collectMenuDropdowns();

        setTimeout(initDropdownWindow, 100);
      }
      else
      {
        setTimeout(initDropdown, 100);
      }
    };

    this.reInitDropdown = (objId, pBtn, pParameters, ddInnerHtmlInit, pCallBackSaveInit, pCallBackCloseInit, pCallBackStopCloseInit, pCallBackWaitCloseInit, pCallBackPreviewInit, newArgs) =>
    {
      const prop = {};

      this.isObjValid = false;
      this.isDataValid = false;
      this.pButton = pBtn;

      dropdownId = objId;
      pButton = pBtn;
      directURL = pParameters.directURL;
      ddInnerHTML = (ddInnerHtmlInit) ? ddInnerHtmlInit : '';
      pCallBackSave = (pCallBackSaveInit && typeof(pCallBackSaveInit) === 'function') ? pCallBackSaveInit : null;
      pCallBackClose = (pCallBackCloseInit && typeof(pCallBackCloseInit) === 'function') ? pCallBackCloseInit : pThis.closeDropdown;
      pCallBackWaitClose = (pCallBackWaitCloseInit && typeof(pCallBackWaitCloseInit) === 'function') ? pCallBackWaitCloseInit : null;
      pCallBackStopClose = (pCallBackStopCloseInit && typeof(pCallBackStopCloseInit) === 'function') ? pCallBackStopCloseInit : function() {};
      pCallBackPreview = (pCallBackPreviewInit && typeof(pCallBackPreviewInit) === 'function') ? pCallBackPreviewInit : null;

      newArgs = newArgs || {};

      for (let k in newArgs)
      {
        if (newArgs.hasOwnProperty(k))
        {
          args[k] = newArgs[k];
          prop[k] = true;
        }
      }

      for (let k in args)
      {
        if (args.hasOwnProperty(k))
        {
          if (!prop.hasOwnProperty(k))
          {
            delete args[k];
          }
        }
      }

      if (pParameters.callBackParameters)
      {
        for (let i in pParameters.callBackParameters)
        {
          if (pParameters.callBackParameters.hasOwnProperty(i) && typeof(pParameters.callBackParameters[i]) !== 'function')
          {
            pCallBackParameters[i] = pParameters.callBackParameters[i];
          }
        }
      }

      if (iFrame)
      {
        iFrame.isIFrameReloading = true;
      }

      try
      {
        if (args.isReload)
        {
          iFrame.location.reload(true);
        }
        else
        {
          iFrame.location.replace(directURL);
        }
      }
      catch (err)
      {
      }

      collectMenuDropdowns();

      setTimeout(initDropdownWindow, 100);
    };


    function collectMenuDropdowns()
    {
      let currentChildMenuDropdown,
          menuDropdownIndex = dropdownId.match(/^(.*?_Level)(\d+)$/i);

      childMenuDropdown.splice(0, childMenuDropdown.length);

      if (menuDropdownIndex && menuDropdownIndex[1] != null && menuDropdownIndex[2] != null)
      {
        menuDropdownIndex[2]++;
        currentChildMenuDropdown = BEditor.dropdowns.getObjectById(menuDropdownIndex[1] + menuDropdownIndex[2]);

        while (currentChildMenuDropdown)
        {
          childMenuDropdown.push(currentChildMenuDropdown);
          menuDropdownIndex[2]++;
          currentChildMenuDropdown = BEditor.dropdowns.getObjectById(menuDropdownIndex[1] + menuDropdownIndex[2]);
        }
      }
    }


    function initDropdownWindow()
    {
      let allElements,
          endOfPageDiv;

      iFrame = frames[iFrameName];

      if (iFrame && iFrame.document && !iFrame.isIFrameReloading && iFrame.document.getElementById('idEndOfPageDiv'))
      {
        iFrame.parentId = dropdownId;
        iFrame.parentObject = pThis;
        iFrame.parentButton = pButton;

        if (pCallBackSave)
        {
          iFrame.callBackSave = pCallBackSave;
        }

        if (pCallBackClose)
        {
          iFrame.callBackClose = pCallBackClose;
        }

        if (pCallBackWaitClose)
        {
          iFrame.callBackWaitClose = pCallBackWaitClose;
        }

        if (pCallBackStopClose)
        {
          iFrame.callBackStopClose = pCallBackStopClose;
        }

        if (pCallBackPreview)
        {
          iFrame.callBackPreview = pCallBackPreview;
        }

        if (isIE)
        {
          iFrameEventElement = iFrame.document.body;
        }
        else
        {
          iFrameEventElement = iFrame;
        }

        iFrame.document.body.onmousedown = function(e) {
          BEditor.domHandlers.stopEventBubbling(e);
        };

        if (isWithoutCSS)
        {
          removeDefaultCSS();
        }

        let parentContainer;

        if (iFrame.document.getElementById('idInnerHTMLContainer'))
        {
          parentContainer = iFrame.document.getElementById('idInnerHTMLContainer');
        }
        else if (iFrame.document.forms[0])
        {
          parentContainer = iFrame.document.forms[0];
        }
        else
        {
          parentContainer = iFrame.document.body;
        }

        scrollableDropdownPanel = new ScrollablePanel(
        {
          'id': 'idDropdownScrollableContentContainer_' + dropdownId,
          'cssClass': 'dropdownScrollableContentContainer',
          'isBorder': true,
          'isNoIndentTemplate': true,
          'contentHTML': ddInnerHTML
        },
        {
          'parentComponent': pThis,
          'window': iFrame,
          'parentContainer': parentContainer,
          'isBorder': true,
          'isNoRightPadding': true,
          scrollBarContainerZIndex: 37373,
          scrollBarSliderZIndex: 37377
        });

        if (!iFrame.document.getElementById('idEndOfPageDiv'))
        {
          endOfPageDiv = iFrame.document.createElement('DIV');
          endOfPageDiv.id = 'idEndOfPageDiv';
          iFrame.document.body.appendChild(endOfPageDiv);
        }

        allElements = iFrame.document.body.getElementsByTagName('*');
        parsingTypeElements(iFrame, allElements);

        scrollablePanelContainer = BEditor.domHelpers.$('idDropdownScrollableContentContainer_' + dropdownId + '_ScrollablePanelContainer', iFrame);

        iFrame.document.body.style.backgroundColor = (isIFrameTransparent ? 'transparent' : iFrameBackgroundColor);
        iFrame.document.body.style.backgroundImage = 'none';
        iFrame.document.body.style.filter = 'none';

        pThis.isObjValid = true;
      }
      else
      {
        setTimeout(initDropdownWindow, 100);
      }
    }

    function parsingTypeElements(pIFrame, allElements)
    {
      let att,
          j = 0,
          itemMenuIndex = 0,
          ddValue,
          currElement;

      pIFrame.typeElements = [];

      for (let i = 0, len = allElements.length; i < len; i++)
      {
        currElement = allElements[i];
        att = currElement.getAttribute('ddtype', 0);
        ddValue = currElement.getAttribute('ddvalue', 0);

        if (att != null)
        {
          pIFrame.typeElements[j] = {};

          pIFrame.typeElements[j].element = allElements[i];
          pIFrame.typeElements[j].type = att;
          pIFrame.typeElements[j].value = null;
          pIFrame.typeElements[j].menuId = null;
          pIFrame.typeElements[j].menuPart = null;

          if (att.toLowerCase() === 'item')
          {
            pIFrame.typeElements[j].value = (ddValue != null) ? ddValue : null;
            currElement.id = 'idItem_' + i;

            currElement.onmouseover = function()
            {
              pThis.currentDropdownId = objId;

              for (let i = 0, len = childMenuDropdown.length; i < len; i++)
              {
                childMenuDropdown[i].closeDropdown(null, null, null, true, true);
              }

              iFrame.mouseOver(this.id);
            };

            currElement.onmouseout = function()
            {
              pThis.currentDropdownId = '';
              pThis.currentMenuDropdownId = '';
              iFrame.mouseOut(this.id);
            };

            currElement.onclick = function(e)
            {
              pThis.currentDropdownId = '';
              pThis.currentMenuDropdownId = '';
              pIFrame.mouseClick(this.id, e);
            };
          }
          else if (att.toLowerCase() === 'itemmenu')
          {
            pIFrame.typeElements[j].menuId = (currElement.getAttribute('ddmenuid', 0) != null) ? currElement.getAttribute('ddmenuid', 0) : null;
            pIFrame.typeElements[j].menuPart = (currElement.getAttribute('ddmenupart', 0) != null) ? currElement.getAttribute('ddmenupart', 0) : null;
            allElements[i].id = 'idItemMenu_' + i;

            dropdownMenuItems[itemMenuIndex] = {};
            dropdownMenuItems[itemMenuIndex].id = 'idItemMenu_' + i;
            dropdownMenuItems[itemMenuIndex].item = new ItemDropdownMenu(pThis, dropdownMenuItems[itemMenuIndex].id, allElements[i]);
            itemMenuIndex++;
          }

          j++;
        }
      }
    }


    function removeDefaultCSS()
    {
      const cssLinks = iFrame.document.getElementsByTagName('LINK');

      if (cssLinks && cssLinks.length)
      {
        for (let i = 0; i < cssLinks.length; i++)
        {
          cssLinks[i].disabled = true;
        }
      }

      iFrame.document.body.style.margin = '0px';
      iFrame.document.body.style.padding = '0px';

      if (!isIE)
      {
        for (let i = 0; i < iFrame.document.styleSheets.length; i++)
        {
          if (!iFrame.document.styleSheets[i].disabled)
          {
            iFrame.document.styleSheets[i].insertRule('P:first-child, H1:first-child, H2:first-child, H3:first-child, H4:first-child, H5:first-child, H6:first-child { margin-top: 0; }', 0);
          }
        }
      }
    }


    pThis.openDropdown = function(pCallBackSaveNew, pCallBackCloseNew, pCallBackWaitCloseNew, pCallBackStopCloseNew, pCallBackPreviewNew, pBtn, sMultiDropdownPartName, pNewParameters, argsNew) {
      argsNew = argsNew || {};

      if (!isNotUnique && !argsNew.isMenuDropdown)
      {
        BEditor.dropdowns.closeAllDropdowns();
      }

      if (pCallBackSaveNew && typeof(pCallBackSaveNew) === 'function')
      {
        pCallBackSave = pCallBackSaveNew;
      }

      if (pCallBackCloseNew && typeof(pCallBackCloseNew) === 'function')
      {
        pCallBackClose = pCallBackCloseNew;
      }

      if (pCallBackWaitCloseNew && typeof(pCallBackWaitCloseNew) === 'function')
      {
        pCallBackWaitClose = pCallBackWaitCloseNew;
      }

      if (pCallBackStopCloseNew && typeof(pCallBackStopCloseNew) === 'function')
      {
        pCallBackStopClose = pCallBackStopCloseNew;
      }

      if (pCallBackPreviewNew && typeof(pCallBackPreviewNew) === 'function')
      {
        pCallBackPreview = pCallBackPreviewNew;
      }

      if (pBtn)
      {
        pThis.pButton = pBtn;
        pButton = pBtn;
      }

      if (argsNew.pCallBackClosed)
      {
        args.pCallBackClosed = argsNew.pCallBackClosed;
      }

      multiDropdownPartName = (sMultiDropdownPartName) ? sMultiDropdownPartName : null;
      newParameters = pNewParameters || {};

      try
      {
        scrollableDropdownPanel.calculate(); //TODO Dime: fix bug
      }
      catch (e)
      {
        return false;
      }

      openDropdownStep1(argsNew.ddArgs);
    };

    function hideAllMultiDropDownParts()
    {
      let partContainer;

      for (let partId in shownMultiDropDownParts)
      {
        if (shownMultiDropDownParts.hasOwnProperty(partId))
        {
          partContainer = shownMultiDropDownParts[partId];

          partContainer.style.height = 'auto';
          partContainer.style.position = 'absolute';
          partContainer.style.left = '-3700px';
          partContainer.style.top = '-3700px';
        }
      }

      shownMultiDropDownParts = {};
    }


    function showMultiDropDownPart(partId, partContainer, width, height)
    {
      if (shownMultiDropDownParts.hasOwnProperty(partId))
      {
        return;
      }

      partContainer.style.position = 'relative';
      partContainer.style.left = '0px';
      partContainer.style.top = '0px';
      partContainer.style.width = width + 'px';
      partContainer.style.height = height + 'px';

      shownMultiDropDownParts[partId] = partContainer;
    }


    function openDropdownStep1(ddArgs)
    {
      if (pThis.isObjValid)
      {
        let ddWidth,
            ddHeight,
            excludeWindows = {};

        excludeWindows[iFrame.name] = true;

        if (multiDropdownPartName && multiDropdownStructure && multiDropdownStructure[multiDropdownPartName])
        {
          dropdownInnerMainContainer = iFrame.document.getElementById(multiDropdownStructure[multiDropdownPartName].containerId);
          dropdownInnerContainer = iFrame.document.getElementById(multiDropdownStructure[multiDropdownPartName].childContainerId);
          isMultiDropdown = true;
        }
        else
        {
          dropdownInnerMainContainer = iFrame.document.getElementById('idDropdownInnerMainContainer');
          isMultiDropdown = false;
        }

        returnParameters = {};

        if (pCallBackParameters)
        {
          for (let k in pCallBackParameters)
          {
            if (pCallBackParameters.hasOwnProperty(k) && typeof(pCallBackParameters[k]) !== 'function')
            {
              returnParameters[k] = pCallBackParameters[k];
            }
          }

          iFrame.callBackParameters = returnParameters;
        }

        iFrame.callBackSave = pCallBackSave;
        iFrame.callBackClose = pCallBackClose;
        iFrame.callBackWaitClose = pCallBackWaitClose;
        iFrame.callBackStopClose = pCallBackStopClose;
        iFrame.callBackPreview = pCallBackPreview;

        iFrame.openInitDropdown(ddArgs);

        if (isMultiDropdown && dropdownInnerMainContainer)
        {
          ddWidth = dropdownInnerMainContainer.offsetWidth;
          ddHeight = dropdownInnerMainContainer.offsetHeight;
          hideAllMultiDropDownParts();
          showMultiDropDownPart(dropdownInnerContainer.id, dropdownInnerMainContainer, ddWidth, ddHeight);
        }

        calculatePosition();

        if (changeStateTM) clearTimeout(changeStateTM);

        changeStateTM = setTimeout(function()
        {
          objMainBox.style.visibility = 'visible';
          pThis.changeState(1);
        }, 30);

        if (addHandlersTM) clearTimeout(addHandlersTM);

        addHandlersTM = setTimeout(function()
        {
          const componentFrame = BEditor.window.getAltScrollContainer(BEditor.environment.topWindow);

          BEditor.domHandlers.addHandler(iFrameEventElement, 'blur', pThis.closeDropdownWait);
          BEditor.domHandlers.addHandler(iFrameEventElement, 'focus', pThis.closeDropdownStop);

          BEditor.globalHandlers.addGlobalHandler('window', 'blur', pThis.closeDropdownWait, objId + '_CloseDropdownWhenBlurWindow');
          BEditor.globalHandlers.addGlobalHandler('window', 'focus', pThis.closeDropdownStop, objId + '_StopCloseDropdownWhenFocusWindow');
          BEditor.globalHandlers.addGlobalHandler('window', 'mousedown', pThis.closeDropdown, objId + '_CloseDropdownWhenMouseDownWindow', {'excludeWindows': excludeWindows});
          BEditor.globalHandlers.addGlobalHandler('window', 'keydown', keyDown, objId + '_CloseDropdownWhenKeyPressWindow');

          BEditor.domHandlers.addHandler(window, 'resize', pThis.closeDropdown);
          BEditor.domHandlers.addHandler(window, 'scroll', calculatePosition);

          if (BEditor.AdminPanel && BEditor.environment.topWindow.contentarea)
          {
            BEditor.domHandlers.addHandler(BEditor.environment.topWindow.contentarea, 'scroll', calculatePosition);
          }

          if (componentFrame)
          {
            BEditor.domHandlers.addHandler(componentFrame, 'scroll', calculatePosition);
          }

          pThis.DropDownShowed.fireHandlers();
        }, 100);
      }
    }

    function calculatePosition()
    {
      if (pThis.isObjValid)
      {
        let buttonCoord = pButton.getButtonXY(multiDropdownPartName),
          buttonLeft = buttonCoord[0],
          buttonTop = buttonCoord[1],
          buttonWidth = buttonCoord[2],
          buttonHeight = buttonCoord[3],
          isPositionFixed = buttonCoord[4],
          currentDropdownAlign = (newParameters.dropdownAlign) ? newParameters.dropdownAlign : dropdownAlign,
          currentEdgeAlign = (newParameters.edgeAlign) ? newParameters.edgeAlign : edgeAlign,
          currentOffsetX = (newParameters.offsetX) ? newParameters.offsetX : offsetX,
          currentOffsetY = (newParameters.offsetY) ? newParameters.offsetY : offsetY,
          windowSizes = BEditor.window.getWindowSizes(window),
          dbWidth = (BEditor.device.isDesktop ? windowSizes.clientWidth : windowSizes.innerWidth),
          dbHeight = (BEditor.device.isDesktop ? windowSizes.clientHeight : windowSizes.innerHeight),
          dbScrollTop = windowSizes.scrollTop - (!isPositionFixed ? windowSizes.altScrollTop : 0),
          topWinScrollLeft = BEditor.AdminPanel ? windowSizes.scrollLeft - (!isPositionFixed ? windowSizes.altScrollLeft : 0) : 0,
          topWinScrollTop = BEditor.AdminPanel ? windowSizes.scrollTop - (!isPositionFixed ? windowSizes.altScrollTop : 0) : 0,
          ddLeft,
          ddTop,
          ddWidth = dropdownInnerMainContainer.offsetWidth,
          ddHeight = dropdownInnerMainContainer.offsetHeight,
          containerBox;

        ddTop = buttonTop + buttonHeight + currentOffsetY + topWinScrollTop;

        if (currentDropdownAlign === 'right')
        {
          ddTop = ddTop - buttonHeight + topWinScrollTop;

          ddLeft = buttonLeft + buttonWidth + currentOffsetX + topWinScrollLeft;
        }
        else
        {
          if (currentEdgeAlign === 'center')
          {
            ddLeft = buttonLeft - Math.floor((ddWidth - buttonWidth) / 2) + currentOffsetX + topWinScrollLeft;
          }
          else if (currentEdgeAlign === 'right')
          {
            ddLeft = buttonLeft - (ddWidth - buttonWidth) + currentOffsetX + topWinScrollLeft;
          }
          else
          {
            ddLeft = buttonLeft + topWinScrollLeft;
          }
        }

        if (ddLeft + ddWidth > dbWidth + topWinScrollLeft)
        {
          ddLeft = buttonLeft - ddWidth + topWinScrollLeft;
        }

        if (ddTop + ddHeight + 17 > dbHeight + dbScrollTop)
        {
          ddHeight = dbHeight - ddTop + dbScrollTop - 17;

          containerBox = BEditor.dimensions.getElementBox(dropdownInnerMainContainer);
          dropdownInnerMainContainer.style.height = (ddHeight - containerBox.deltaInnerHeight) + 'px';
        }

        objMainBox.style.left = ddLeft + 'px';
        objMainBox.style.top = ddTop + 'px';
        objMainBox.style.width = (ddWidth + 2) + 'px';
        objMainBox.style.height = (ddHeight + 2) + 'px';

        scrollableDropdownPanel.calculate();
      }
    }


    this.keyPress = function(e)
    {
      keyDown(e);
    };

    function keyDown(e = window.event)
    {
      if (e && BEditor.utils.getKeyCode(e) === 27)
      {
        pThis.closeDropdown(null, null, null, false, false);
      }
    }

    this.closeDropdownWait = () =>
    {
      if (closeDropdownWaitTM) clearTimeout(closeDropdownWaitTM);

      if (iFrame.callBackWaitClose)
      {
        iFrame.callBackWaitClose();
      }
      else
      {
        closeDropdownWaitTM = setTimeout(pThis.closeDropdown, 50);
      }
    };

    this.closeDropdownStop = () =>
    {
      if (closeDropdownWaitTM) clearTimeout(closeDropdownWaitTM);

      for (let i = 0; i < dropdownMenuItems.length; i++)
      {
        dropdownMenuItems[i].item.closeDropdownStop();
      }

      iFrame.callBackStopClose();
    };


    this.closeDropdownDo = () =>
    {
      iFrame.callBackClose();
    };


    this.closeDropdown = (e, win, handlerArgs, isDropdownMenuItem, isSkipMenuDropdown) =>
    {
      if (!this.isObjValid || objId === BEditor.dropdowns.currentDropdownId || objId === BEditor.dropdowns.currentMenuDropdownId)
      {
        return false;
      }

      if (!state)
      {
        return true;
      }

      if (!isSkipMenuDropdown)
      {
        for (let i = 0; i < dropdownMenuItems.length; i++)
        {
          dropdownMenuItems[i].item.closeMenuDropdown();
        }
      }

      if (addHandlersTM) clearTimeout(addHandlersTM);

      BEditor.domHandlers.removeHandler(iFrameEventElement, 'blur', this.closeDropdownWait);
      BEditor.domHandlers.removeHandler(iFrameEventElement, 'focus', this.closeDropdownStop);

      BEditor.globalHandlers.removeGlobalHandler(objId + '_CloseDropdownWhenBlurWindow');
      BEditor.globalHandlers.removeGlobalHandler(objId + '_StopCloseDropdownWhenFocusWindow');
      BEditor.globalHandlers.removeGlobalHandler(objId + '_CloseDropdownWhenMouseDownWindow');
      BEditor.globalHandlers.removeGlobalHandler(objId + '_CloseDropdownWhenKeyPressWindow');
      BEditor.globalHandlers.removeGlobalHandler(objId + '_CloseDropdownWhenMouseDownDocument');
      BEditor.globalHandlers.removeGlobalHandler(objId + '_CloseDropdownWhenMouseDownBody');

      BEditor.domHandlers.removeHandler(window, 'resize', this.closeDropdown);
      BEditor.domHandlers.removeHandler(window, 'scroll', calculatePosition);

      if (BEditor.AdminPanel && BEditor.environment.topWindow.contentarea)
      {
        BEditor.domHandlers.removeHandler(BEditor.environment.topWindow.contentarea, 'scroll', calculatePosition);
      }

      iFrame.document.body.onkeypress = null;

      objMainBox.style.visibility = 'hidden';
      objMainBox.style.left = '-3700px';
      objMainBox.style.top = '-3700px';
      objMainBox.style.width = '1px';
      objMainBox.style.height = '1px';

      if (isMultiDropdown)
      {
        hideAllMultiDropDownParts();
      }
      else if (dropdownInnerMainContainer)
      {
        dropdownInnerMainContainer.style.height = 'auto';
      }

      if (iFrame.closeInitDropdown)
      {
        iFrame.closeInitDropdown();
      }

      if (args.pCallBackClosed)
      {
        args.pCallBackClosed();
      }

      if (changeStateTM) clearTimeout(changeStateTM);
      changeStateTM = setTimeout(() => { pThis.changeState(0, isDropdownMenuItem); }, 10);
    };


    this.getReturnedParameters = () =>
    {
      return returnParameters;
    };


    this.setReturnedParameters = (param, value) =>
    {
      pCallBackParameters[param] = value;
    };


    this.setBodyIdAndClass = (bodyId, bodyClass) =>
    {
      if (this.isObjValid)
      {
        iFrame.document.body.id = bodyId;
        iFrame.document.body.className = bodyClass;

        if (isIFrameTransparent)
        {
          iFrame.document.body.style.backgroundColor = 'transparent';
          iFrame.document.body.style.backgroundImage = 'none';
          iFrame.document.body.style.filter = 'none';
        }

        iFrame.document.body.style.textAlign = 'left';
      }
    };


    this.changeState = (st, isStopFire) =>
    {
      state = !!st;

      if (!state && !isStopFire)
      {
        this.DropDownHidden.fireHandlers();
      }
    };


    this.getState = (partName) =>
    {
      if (multiDropdownPartName && partName)
      {
        return state && (multiDropdownPartName === partName);
      }

      return state;
    };


    this.getButton = () => pButton;
    this.getWindow = () => iFrame;
    this.getDocument = () => iFrame.document;
    this.get$ = (id) => (iFrame && iFrame.document) ? iFrame.document.getElementById(id) : null;
    this.getDropdownXY = () => ({'X': objMainBox.offsetLeft, 'Y': objMainBox.offsetTop});
    this.getMultiDropdownPartName = () => multiDropdownPartName;


    this.pageUnload = () =>
    {
      if (!this.isObjValid)
      {
        return false;
      }

      this.destructor();
    };


    this.destructor = () =>
    {
      if (iFrame)
      {
        if (iFrame.parentId)
        {
          iFrame.parentId = null;
        }

        if (iFrame.moveWindow)
        {
          iFrame.moveWindow = null;
        }

        if (iFrame.keyPress)
        {
          iFrame.keyPress = null;
        }

        objMainBoxCont.removeChild(objMainBox);
        document.body.removeChild(objMainBoxCont);

        scrollableDropdownPanel.destructor();
      }
    };


    setTimeout(initDropdown, 200);


    function ItemDropdownMenu(pParent, itemId, itemMenu)
    {
      let pThis = this;

      const dropdownButtonContainer = itemMenu,
            childMenuDropdown = [];

      let menuId,
          menuPart,
          menuDropdown,
          menuDropdownIndex,
          currentChildMenuDropdown,
          closeMenuDropdownTM = null,
          closeDropdownTM = null;

      pThis.init = init;
      pThis.closeDropdownWait = closeDropdownWait;
      pThis.closeMenuDropdownStop = closeMenuDropdownStop;
      pThis.closeDropdownStop = closeDropdownStop;
      pThis.closeAllDropdownStop = closeAllDropdownStop;
      pThis.closeMenuDropdown = closeMenuDropdown;
      pThis.closeDropdown = closeDropdown;
      pThis.getButtonXY = getButtonXY;

      init();

      function init()
      {
        menuId = dropdownButtonContainer.getAttribute('ddmenuid', 0);
        menuPart = dropdownButtonContainer.getAttribute('ddmenupart', 0);
        menuDropdown = BEditor.dropdowns.getObjectById(menuId);

        menuDropdownIndex = menuId.match(/^(.*?_Level)(\d+)$/i);

        if (menuDropdownIndex && menuDropdownIndex[1] != null && menuDropdownIndex[2] != null)
        {
          menuDropdownIndex[2]++;
          currentChildMenuDropdown = BEditor.dropdowns.getObjectById(menuDropdownIndex[1] + menuDropdownIndex[2]);

          while (currentChildMenuDropdown)
          {
            childMenuDropdown.push(currentChildMenuDropdown);
            menuDropdownIndex[2]++;
            currentChildMenuDropdown = BEditor.dropdowns.getObjectById(menuDropdownIndex[1] + menuDropdownIndex[2]);
          }
        }

        dropdownButtonContainer.onmouseover = function()
        {
          let ddValue = this.getAttribute('ddvalue', 0),
              ddTitle = this.getAttribute('ddtitle', 0),
              ddDisabled = this.getAttribute('dddisabled', 0);

          BEditor.dropdowns.currentDropdownId = objId;

          if (ddDisabled && ddDisabled.toLowerCase() === 'true')
          {
            return;
          }

          iFrame.mouseOver(this.id);

          for (let i = 0; i < childMenuDropdown.length; i++)
          {
            childMenuDropdown[i].closeDropdown(null, null, null, true, true);
          }

          for (let i = 0; i < dropdownMenuItems.length; i++)
          {
            dropdownMenuItems[i].item.closeMenuDropdown();
          }

          closeAllDropdownStop();

          if (ddValue)
          {
            menuDropdown.setReturnedParameters('itemMenuCommand', ddValue);
          }

          if (ddTitle)
          {
            menuDropdown.setReturnedParameters('itemMenuTitle', ddTitle);
          }

          if (menuDropdown.getState())
          {
            if (changeStateTM) clearTimeout(changeStateTM);
            closeAllDropdownStop();
          }

          BEditor.dropdowns.currentMenuDropdownId = menuDropdown.getId();
          menuDropdown.openDropdown(setValue, closeDropdown, closeDropdownWait, closeAllDropdownStop, null, pThis, menuPart, null, {'isMenuDropdown': true});
        };


        dropdownButtonContainer.onmouseout = function()
        {
          const ddDisabled = this.getAttribute('dddisabled', 0);

          BEditor.dropdowns.currentDropdownId = '';
          BEditor.dropdowns.currentMenuDropdownId = '';

          if (ddDisabled && ddDisabled.toLowerCase() === 'true')
          {
            return;
          }

          iFrame.mouseOut(this.id);
        };
      }


      function getButtonXY()
      {
        let parTemp,
            pDropdownCoords = pParent.getDropdownXY(),
            offsetXY = BEditor.dimensions.getXY(dropdownButtonContainer),
            objX = offsetXY.x,
            objY = offsetXY.y,
            parTempScrollX,
            parTempScrollY,
            scrollX = 0,
            scrollY = 0;

        objX += pDropdownCoords.X;
        objY += pDropdownCoords.Y;

        parTemp = dropdownButtonContainer.parentNode;

        while (parTemp)
        {
          parTempScrollX = parTemp.scrollLeft;
          parTempScrollY = parTemp.scrollTop;
          scrollX += !isNaN(parTempScrollX) ? parTempScrollX : 0;
          scrollY += !isNaN(parTempScrollY) ? parTempScrollY : 0;
          parTemp = parTemp.parentNode;
        }

        objX -= scrollX;
        objY -= scrollY;

        return [objX, objY, dropdownButtonContainer.offsetWidth, dropdownButtonContainer.offsetHeight];
      }


      function setValue()
      {
        const pParameters = menuDropdown.getReturnedParameters();

        for (let k in pParameters)
        {
          if (pParameters.hasOwnProperty(k) && typeof(pParameters[k]) !== 'function')
          {
            iFrame.callBackParameters[k] = pParameters[k];
          }
        }

        iFrame.callBackSave();
      }


      function closeDropdownWait()
      {
        if (closeMenuDropdownTM) clearTimeout(closeMenuDropdownTM);
        closeMenuDropdownTM = setTimeout(closeMenuDropdown, 777);

        if (closeDropdownTM) clearTimeout(closeDropdownTM);
        closeDropdownTM = setTimeout(closeDropdown, 777);
      }


      function closeMenuDropdownStop()
      {
        if (closeMenuDropdownTM) clearTimeout(closeMenuDropdownTM);
      }


      function closeDropdownStop()
      {
        if (closeDropdownTM) clearTimeout(closeDropdownTM);
      }


      function closeAllDropdownStop()
      {
        if (closeMenuDropdownTM) clearTimeout(closeMenuDropdownTM);
        if (closeDropdownTM) clearTimeout(closeDropdownTM);
        pParent.closeDropdownStop();
      }


      function closeMenuDropdown()
      {
        if (closeMenuDropdownTM) clearTimeout(closeMenuDropdownTM);
        menuDropdown.closeDropdown(null, null, null, true, false);
      }


      function closeDropdown()
      {
        if (closeDropdownTM) clearTimeout(closeDropdownTM);
        pParent.closeDropdownDo();
      }
    }
  }


  const scrollablePanelCss =
    [
      'DIV.scrollablePanelContainer { position: relative; }',
      'DIV.scrollablePanelWrapper { overflow: hidden; }',
      'DIV.scrollablePanelContainer DIV.scrollablePanelWrapper ::-webkit-scrollbar, DIV.scrollablePanelContainer DIV.scrollablePanelWrapper ::-webkit-scrollbar-button, DIV.scrollablePanelContainer DIV.scrollablePanelWrapper ::-webkit-scrollbar-track, DIV.scrollablePanelContainer DIV.scrollablePanelWrapper ::-webkit-scrollbar-track-piece, DIV.scrollablePanelContainer DIV.scrollablePanelWrapper ::-webkit-scrollbar-thumb, DIV.scrollablePanelContainer DIV.scrollablePanelWrapper ::-webkit-scrollbar-corner, DIV.scrollablePanelContainer DIV.scrollablePanelWrapper ::-webkit-resizer { width: 0; }',
      'DIV.scrollBarContainer, DIV.scrollBarSlider { background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAABCAMAAAC1xj0zAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAFFQTFRFysrK39/fxMTEtbW12tra9vb26+vroqKi5ubmlpaW0NDQwcHB4ODg29vb1NTU4+Pj/f397u7ut7e38fHx4eHh3d3d8vLy+vr65+fnz8/P7e3tunUk0AAAADhJREFUeNpi4OZiYQQDFnZmJgYwYEKwhFgFxFnFBNlYJTk5hKUkeFj4OJg52Vh4RRlF+NmYAQIMACUMAa+nFZs1AAAAAElFTkSuQmCC); background-repeat: repeat-y; }',
      'DIV.scrollBarContainer { position: absolute; right: 0; top: 0; z-index: 3; width: 10px; overflow: hidden; background-color: #DFDFDF; cursor: default; }',
      'DIV.scrollBarTop, DIV.scrollBarBottom, DIV.scrollBarSliderTop, DIV.scrollBarSliderMiddle, DIV.scrollBarSliderBottom { position: absolute; left: 0; width: 10px; overflow: hidden; background-color: transparent; background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAATCAMAAACwcE1OAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQhQTFRF////ysrK39/fxMTEtbW12tra9vb26+vroqKi5ubmlpaW0NDQwcHB4ODg29vb1NTU4+Pj/f397u7ut7e38fHx4eHh3d3d8vLy+vr65+fnz8/P7e3txcXFzMzMp6enwMDAw8PDxsbGpaWlj4+Pvb295eXlurq6oaGh+/v7uLi40tLStLS0u7u7vr6+0dHRnZ2doKCgmJiY1tbWl5eXjIyMjY2Nzc3N2NjYi4uLwsLCubm5lJSUkJCQ8PDwv7+/3Nzc+fn59/f37Ozs1dXVm5ubqKio7+/vpqamlZWVtra2o6Oj4uLinp6empqazs7On5+fsbGxvLy819fXqqqq2dnZrKysyMjI////b2CjvQAAAFh0Uk5T////////////////////////////////////////////////////////////////////////////////////////////////////////////////////AHibwggAAAEqSURBVHjaxJDrVoJAFEaPw2UckYsomqnhDRQwFLuYllJappWW3Xj/NwkGjdUTtP/MXmev+fPBLsvsue80TyjNxCArcIjCpVkmRWESA92e8yGV0XYwGWqEaO9jZ2ByBsaGVHdgV+ge8SV1WbI3ojovixKnrTcGKhbRMyFrmPC5KGNe8EihUhY5meQ9zElFpCk4D9ZvXh2yszpkB4IgiHJAiXJsUQ6fKF+mGvX4eHbduort/KJ1s8+57u1dfISQP/avv60lXU2dChkUryayGQX54WqGwcLkexptPnVd72OLCEFu3vK+bAVjRbYsaGdnpyH14+HLU3rQ778+srPEQK+5C1leDKXPzpvZ7vXaenWcGFRtX6T4D2ajRmkkBowwkiijJqtXKXpiPwIMAEGFW/e/LsLPAAAAAElFTkSuQmCC); background-repeat: no-repeat; cursor: default; }',
      'DIV.scrollBarTop, DIV.scrollBarBottom { height: 2px; z-index: 4; }',
      'DIV.scrollBarTop { top: 0; }',
      'DIV.scrollBarBottom { bottom: 0; }',
      'DIV.scrollBarSlider { position: absolute; left: 0; top: 1px; z-index: 5; width: 10px; overflow: hidden; background-color: #F7F7F7; cursor: default; }',
      'DIV.scrollBarSliderTop, DIV.scrollBarSliderMiddle, DIV.scrollBarSliderBottom { z-index: 7; }',
      'DIV.scrollBarSliderTop, DIV.scrollBarSliderBottom { height: 4px; }',
      'DIV.scrollBarSliderTop { top: 0; }',
      'DIV.scrollBarSliderMiddle { height: 7px; }',
      'DIV.scrollBarSliderBottom { bottom: 0; }',
      'DIV.scrollBarContainerNormal { background-position: 0 0; }',
      'DIV.scrollBarContainerNormal DIV.scrollBarTop { background-position: 0 0; }',
      'DIV.scrollBarContainerNormal DIV.scrollBarBottom { background-position: 0 -17px; }',
      'DIV.scrollBarContainerNormal DIV.scrollBarSlider { background-position: -30px 0; }',
      'DIV.scrollBarContainerNormal DIV.scrollBarSliderTop { background-position: 0 -2px; }',
      'DIV.scrollBarContainerNormal DIV.scrollBarSliderMiddle { background-position: 0 -6px; }',
      'DIV.scrollBarContainerNormal DIV.scrollBarSliderBottom { background-position: 0 -13px; }',
      'DIV.scrollBarContainerOver { background-position: -10px 0; }',
      'DIV.scrollBarTop { background-position: -10px 0; }',
      'DIV.scrollBarContainerOver DIV.scrollBarBottom { background-position: -10px -17px; }',
      'DIV.scrollBarContainerOver DIV.scrollBarSlider { background-position: -40px 0; }',
      'DIV.scrollBarContainerOver DIV.scrollBarSliderTop { background-position: -10px -2px; }',
      'DIV.scrollBarContainerOver DIV.scrollBarSliderMiddle { background-position: -10px -6px; }',
      'DIV.scrollBarContainerOver DIV.scrollBarSliderBottom { background-position: -10px -13px; }',
      'DIV.scrollBarContainerActive { background-position: -20px 0; }',
      'DIV.scrollBarContainerActive DIV.scrollBarTop { background-position: -20px 0; }',
      'DIV.scrollBarContainerActive DIV.scrollBarBottom { background-position: -20px -px; }',
      'DIV.scrollBarContainerActive DIV.scrollBarSlider { background-position: -50px 0; }',
      'DIV.scrollBarContainerActive DIV.scrollBarSliderTop { background-position: -20px -2px; }',
      'DIV.scrollBarContainerActive DIV.scrollBarSliderMiddle { background-position: -20px -6px; }',
      'DIV.scrollBarContainerActive DIV.scrollBarSliderBottom { background-position: -20px -13px; }',
      'DIV.scrollablePanelContentContainer { overflow-x: hidden; overflow-y: scroll; visibility: hidden; }',
      'DIV.scrollablePanelContent { }',
      'DIV.scrollablePanelContainerBorder { border: 1px solid #C4C4C4; border-right-color: #DBDBDB; border-bottom-color: #DBDBDB; border-radius: 2px; }'
    ];
}
